"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _coreSc = require("@smooth-ui/core-sc");

var NavLogo = _coreSc.styled.div.withConfig({
  displayName: "NavLogo",
  componentId: "sc-8phgcn-0"
})(["position:relative;height:55px;padding:8px 0;z-index:10;", ""], function (p) {
  return p.mobileOnly && (0, _coreSc.up)('md', (0, _coreSc.css)(["display:none;"]));
});

var _default = NavLogo;
exports["default"] = _default;